module.exports = __webpack_public_path__ + "static/media/trash.b4ba6bd8.svg";